import graphqlRequest from '../assignmentRequest'
import GET_SCREENING_WINDOWS from './graphql'

export async function getScreeningWindows(payload) {
    const {schoolId, dateStart, dateEnd,defaultEntities} = payload
    const response = await graphqlRequest(GET_SCREENING_WINDOWS, {
        schoolId, dateStart, dateEnd, defaultEntities
    })
    return response.assignment;
}